import { render, staticRenderFns } from "./Chains.vue?vue&type=template&id=7a4c9b6a&"
import script from "./Chains.vue?vue&type=script&lang=js&"
export * from "./Chains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports